import * as types from "../../actionTypes";

const initialState = {
  data: {},
  isLoading: false,
  message: "",
  status: "",
};

const workSampleReducer = (state = initialState, action) => {
  console.log("prd", action);
  switch (action.type) {
    case types.ADD_WORK_SAMPLE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.ADD_WORK_SAMPLE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case types.ADD_WORK_SAMPLE_FAILURE:
      console.log(action.payload);
      return {
        ...state,
        isLoading: false,
        data: {},
        status: action.payload.status,
        message: action.payload.message,
      };
    case types.DELETE_WORK_SAMPLE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.DELETE_WORK_SAMPLE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case types.DELETE_WORK_SAMPLE_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case types.RESET_DATA:
      return {
        ...state,
        isLoading: false,
        data: {},
        status: false,
        message: "",
      };

    default:
      return state;
  }
};

export default workSampleReducer;
